import i18n from 'i18n';
import * as Yup from 'yup'; // Ensure Yup is imported

export const schema = Yup.object().shape({
  patient: Yup.string().nullable().required(i18n.t('Required')),
  teamMember: Yup.string().nullable().required(i18n.t('Required')),
  acceptOnBehalfOfPatient: Yup.boolean().nullable(),
  eventType: Yup.string().nullable().required(i18n.t('Required')),
  date: Yup.string().nullable().required(i18n.t('Required')),
  isOnline: Yup.boolean(),
  locationId: Yup.string().when(['teamMember', 'isOnline'], {
    is: (teamMember, isOnline) => {
      return !!teamMember && !isOnline;
    },
    then: (schema) => schema.required(i18n.t('Required')),
  }),
  reservationMode: Yup.object({
    name: Yup.string().required(i18n.t('Required')),
    id: Yup.string().required(i18n.t('Required')),
  })
    .nullable()
    .default(undefined),
  room: Yup.object({
    id: Yup.string().nullable(),
  })
    .nullable()
    .test(
      'valid-room-for-appointment',
      i18n.t('Room does not support the selected reservation mode'),
      function (value) {
        try {
          const { isOnline, locationId, reservationMode } = this.parent;
          if (!value || !value.id) return true;

          if (reservationMode) {
            if (!isOnline && locationId !== value?.organization?.location?.id) {
              return this.createError({
                message: i18n.t('Selected room is not supported by location'),
              });
            }

            // Ensure that value and reservationModes are defined before accessing them
            if (
              value?.reservationModes &&
              Array.isArray(value.reservationModes)
            ) {
              return value.reservationModes.some(
                (i) => i.reservationMode.id === reservationMode.id
              );
            }
          }

          return false;
        } catch (error) {
          return this.createError({
            message: i18n.t('Please select another room'),
          });
        }
      }
    ),
});
